import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import type { TrafficSource } from "@/types/analytics.types";

interface TrafficSourcesChartProps {
  sources: TrafficSource[];
}

export const TrafficSourcesChart = ({ sources }: TrafficSourcesChartProps) => {
  const chartData = sources.map(source => ({
    name: source.source,
    Sitzungen: source.sessions,
    Conversions: source.conversions,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Traffic-Quellen</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis 
              dataKey="name" 
              className="text-xs"
              tick={{ fill: 'hsl(var(--foreground))' }}
            />
            <YAxis 
              className="text-xs"
              tick={{ fill: 'hsl(var(--foreground))' }}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: 'hsl(var(--background))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
              }}
            />
            <Legend />
            <Bar dataKey="Sitzungen" fill="hsl(var(--primary))" />
            <Bar dataKey="Conversions" fill="hsl(var(--accent))" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
